import { useDisclosure, useToast } from "@chakra-ui/react";
import axios from "axios";
import { id } from "date-fns/locale";
import { CondicaoPagamento } from "models/condicao_pagamento_type";
import { ContatoType } from "models/contato_type";
import { OSType } from "models/os_type";
import { PessoaType } from "models/person_type";
import { Project, ProjectCategory, ProjectCategoryItem } from "models/project_type";
import { UsuarioModel } from "models/user_model";
import { useEffect, useRef, useState } from "react";

const useAdm = () => {
  const modalDisclosure = useDisclosure()
  const toast = useToast({
    position: "top-right",
    duration: 3000,
  })

  const [osList, setOsList] = useState<OSType[]>([]);
  const [list1, setList] = useState<Project[]>([]);
  const [osIdDelete, setOsIdDelete] = useState('');
  const [showContaPagarModal, setShowContaPagar] = useState(false);
  const [usuario, setUsuario] = useState<UsuarioModel>();
  const [users, setUsers] = useState<UsuarioModel[]>([]);
  const [selectedOrder1, setSelectedOrder] = useState<Project>(null);
  const [show1, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [initialProject, setInitialProject] = useState(false);
  const [clients, setClientes] = useState<PessoaType[]>([]);
  const [contatoCliente1, setContatoCliente] = useState<ContatoType>(null);
  const [contatoAgencia1, setContatoAgencia] = useState<ContatoType>(null);
  const [fornecedores, setFornecedores] = useState<PessoaType[]>([]);
  const [condicaoPagamento, setCondicaoPagamento] = useState<CondicaoPagamento[]>([]);

  const [error, setError] = useState(false);
  const [errorTitle, setErrorTitle] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const cancelAlertModalRef = useRef()


  const showError = (title: string, msg: string) => {
    setError(true);
    setErrorTitle(title);
    setErrorMsg(msg);
  };

  const showModal1 = async (show: boolean, item: Project) => {
    if (show) {
      loadItens(item);
      if (item?.Orcamento?.contatoAgencia) {
        await loadAgencia(item?.Orcamento?.contatoAgencia);
      }
      if (item?.Orcamento?.contatoCliente) {
        await loadClient(item?.Orcamento?.contatoCliente);
      }
      await getOs(item?.id);
    } else {
      setOsList([]);
      setSelectedOrder(null);
    }
    setShow(show);
  };

  const setShowContaPagarModal = (show: boolean, all = false) => {
    setShowContaPagar(show);
    if (!show && all) {
      showModal1(false, null);
    }
  }

  const loadItens = (item: Project) => {
    if (item.ProjetoCategoria.length > 0) {
      setSelectedOrder(item);
    } else {
      const newProject: Project = {
        ...item,
        ProjetoCategoria: item.Orcamento.OrcamentoCategoria.map((value) => {
          const projectCategory: ProjectCategory = {
            aprovado: false,
            descricao: value.descricao,
            executado: 0,
            metaReducao: 0,
            orcado: 0,
            projetoId: item.id,
            trabalhado: 0,
            travado: false,
            valor: value.valor,
            porcentagemManejo: "",
            porcentagemReducao: "",
            valorManejo: "0",
            valorReducao: "0",
            id: "",
            ProjetoItem: value.OrcamentoItem.map((val) => {
              const projectItem: ProjectCategoryItem = {
                id: "",
                projetoCategoriaId: "",
                produtoId: val.produtoId,
                descricao: val.descricao,
                unidadeMedidaId: val.unidadeMedidaId,
                quantidade: val.quantidade,
                valorUn: val.valorUn,
                valorTotal: val.valorTotal,
                orcado: 0,
                trabalhado: 0,
                executado: 0,
                usuarioId: usuario.id,
                aprovado: false,
                metaReducao: 0,
                travado: false,
                produtoNome: val.produtoNome,
                produtoUnidade: val.produtoUnidade,
                produtoUnidadeId: val.produtoUnidadeId,
                unidadeNome: val.unidadeNome,
                porcentagemManejo: "",
                porcentagemReducao: "",
                valorManejo: "0",
                valorReducao: "0",
              };
              return projectItem;
            }),
          };
          return projectCategory;
        }),
      };
      setSelectedOrder(newProject);
      setInitialProject(true);

    }
  };

  const loadContact = async (id: string) => {
    const response = await axios.get(
      process.env.REACT_APP_API_URL + "/projeto/contato/" + id
    );
    if (response.data) {
      return response.data;
    }
  };

  const loadAgencia = async (id: string) => {
    const ca = await loadContact(id);
    if (ca) {
      setContatoAgencia(ca);
    }
  };
  const loadClient = async (id: string) => {
    const cl = await loadContact(id);
    if (cl) {
      setContatoCliente(cl);
    }
  };

  const loadUsers = async () => {
    const userData = JSON.parse(localStorage.getItem("user"));
    setUsuario(userData);
    const response = await axios.get(
      process.env.REACT_APP_API_URL + "/user/list/" + userData?.idEmpresa
    );
    if (response.data) {
      setLoading((prev) => (prev = false));
      setUsers(response.data);
    }
  };

  const loadClients = async () => {
    const userData = JSON.parse(localStorage.getItem("user"));
    setUsuario(userData);
    const response = await axios.get(
      process.env.REACT_APP_API_URL + "/pessoa/list/" + userData?.idEmpresa
    );
    if (response.data) {
      setLoading((prev) => (prev = false));
      setClientes(response.data);
    }
  };

  const loadFornecedores = async () => {
    const userData = JSON.parse(localStorage.getItem("user"));
    setUsuario(userData);
    const response = await axios.get(
      process.env.REACT_APP_API_URL + "/projeto/fornecedor/list/" + userData?.idEmpresa
    );
    if (response.data) {
      setLoading((prev) => (prev = false));
      setFornecedores(response.data);
    }
  };


  const loadCondicaoPagamento = async () => {
    const userData = JSON.parse(localStorage.getItem("user"));
    setUsuario(userData);

    const response = await axios.get(
      process.env.REACT_APP_API_URL + "/condicao-pagamento/list/" + userData?.idEmpresa
    );
    if (response.data) {
      setLoading((prev) => (prev = false));
      setCondicaoPagamento(response.data);
    }
  };

  const getOs = async (projectId: number) => {
    try {
      const userData = JSON.parse(localStorage.getItem("user"));
      setUsuario(userData);

      const response = await axios.get<OSType[]>(
        process.env.REACT_APP_API_URL + "/projeto/OS/list/" + projectId
      );
      if (response.data) {
        setLoading((prev) => (prev = false));
        mergeOsList(response.data)
      }
    } catch (error) {
      console.error("useAdm.getOs: ", error);
      toast({
        title: 'Erro',
        description: 'Houve um problema ao carregar as OS\'s',
        status: 'error',
      });
    }
  }

  const mergeOsList = (items: OSType[]) => {
    if (items?.length <= 0) {
      return;
    }

    const OSs = items.map(item => ({
      id: item.id,
      comercialQtd: Number(item.comercialQtd || 0),
      comercialTotal: Number(item.comercialTotal || 0),
      comercialValorUN: Number(item.comercialValorUN || 0),
      executado: Number(item.executado || 0),
      condicaoPagamentoId: item.condicaoPagamentoId,
      osNum: item.osNum,
      pago: Number(item.pago || 0),
      pessoaId: item.pessoaId,
      producaoQtd: Number(item.producaoQtd || 0),
      producaoTotal: Number(item.producaoTotal || 0),
      producaoValorUn: Number(item.producaoValorUn || 0),
      projetoCategoriaId: item.projetoCategoriaId,
      projetoItemId: item.projetoItemId,
      saldo: Number(item.saldo || 0),
      financeiroGerado: item.financeiroGerado,
      status: item.status,
      trabalhoQtd: Number(item.trabalhoQtd || 0),
      trabalhoTotal: Number(item.trabalhoTotal || 0),
      trabalhoValorUN: Number(item.trabalhoValorUN || 0),
      unidadeMedidaId: item.unidadeMedidaId,
      unidadeNome: item.unidadeNome,
      tipo: item.tipo,
      descricao: item.descricao,
      produtoId: item.produtoId,
      contasPagarId: item.contasPagarId,
    }));

    setOsList(OSs);
  }

  const loadOs = (item: ProjectCategory) => {
    selectedOrder1?.ProjetoCategoria?.map((cl) => {
      if (cl.id === item.id) {
        return item;
      }
      return cl;
    });
    setSelectedOrder(selectedOrder1);
  };

  const saveOsRequest = () => {
    return axios.post<OSType[]>(
      process.env.REACT_APP_API_URL + "/projeto/OS",
      osList
    );
  }

  const saveOs = async () => {
    if (osList.length <= 0) {
      toast({
        title: 'Info',
        description: 'Não possue OS\'s',
        status: 'info',
        isClosable: true,
      });

      return;
    }

    setLoading((prev) => (prev = true));
    toast.promise(saveOsRequest(), {
      success: {
        title: 'Sucesso',
        description: 'OS\'s salvas com sucesso.',
        onCloseComplete: reloadOs,
      },
      error: {
        title: 'Erro',
        description: 'Houve um problema, tente mais tarde.',
        onCloseComplete: () => {
          setLoading((prev) => (prev = false));
        }
      },
      loading: {
        title: 'Carregando',
        description: 'Por favor aguarde...',
      },
    });
  }

  const reloadOs = async () => {
    setLoading((prev) => (prev = true));
    toast.promise(getOs(selectedOrder1.id), {
      success: {
        title: 'Sucesso',
        description: 'OS\'s Carregadas'
      },
      error: {
        title: 'Erro',
        description: 'Houve um problema ao re-carregar OS\'s, tente mais tarde.'
      },
      loading: {
        title: 'Re-carregando OS\'s',
        description: 'Por favor aguarde...',
        onCloseComplete: () => {
          setLoading((prev) => (prev = false));
        },
      },
    });
  }

  const deleteOs = async (id: string) => {
    if (!id) {
      return;
    }

    setOsIdDelete(id);
    modalDisclosure.onOpen()
  }

  const deleteOsRequest = () => {
    if (!osIdDelete) {
      return Promise.reject('ID não encontrado');
    }

    return axios.delete(
      process.env.REACT_APP_API_URL + "/projeto/OS/" + osIdDelete
    );
  }

  const deleteOsExec = () => {
    setLoading((prev) => (prev = true));

    toast.promise(deleteOsRequest(), {
      success: {
        title: 'Sucesso',
        description: 'OS removida com sucesso.',
        onCloseComplete: reloadOs,
      },
      error: {
        title: 'Erro',
        description: 'Houve um problema, tente mais tarde.',
        onCloseComplete: () => {
          setLoading((prev) => (prev = false));
        },
      },
      loading: {
        title: 'Carregando',
        description: 'Por favor aguarde...',
      },
    });
  }

  useEffect(() => {
    const loadOrder = async () => {
      const userData = JSON.parse(localStorage.getItem("user"));
      setUsuario(userData);
      const url = process.env.REACT_APP_API_URL + `/projeto/administrativo/${userData?.idEmpresa}/0`;
      const response = await axios.get(url);
      if (response.data) {
        setList(response.data);
      }
    };
    const loadData = async () => {
      await loadOrder();
      await loadUsers();
      await loadClients();
      await loadFornecedores();
      await loadCondicaoPagamento();
    };
    loadData();
  }, []);

  return {
    list1,
    usuario,
    selectedOrder1,
    show1,
    loading,
    showModal1,
    contatoCliente1,
    contatoAgencia1,
    users,
    clients,
    fornecedores,
    condicaoPagamento,
    loadOs,
    error,
    errorMsg,
    errorTitle,
    loadFornecedores,
    showError,
    osList,
    setOsList,
    saveOs,
    modalDisclosure,
    cancelAlertModalRef,
    deleteOs,
    deleteOsExec,
    showContaPagarModal,
    setShowContaPagarModal,
  };
};


export default useAdm;